/**
 * Parse a JSON string without throwing.
 *
 * Returns null instead of throwing when the input is empty, malformed, or
 * parses to the literal `null` (e.g. a truncated or corrupted cookie). This
 * lets callers treat a bad `iolrUserData` cookie as "logged out" rather than
 * crashing every code path that reads it.
 */
export function safeParseJson<T = any>(value: string | null | undefined): T | null {
  if (!value) {
    return null;
  }
  try {
    return JSON.parse(value) ?? null;
  } catch {
    return null;
  }
}
